import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Fade, Flex, Img, Text} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import PriceCard from '../price-card'
import {Link as RouteLink} from 'react-router-dom'
import StockLabel from '../stock-label'
import {getDamBaseUrl} from '../../custom-hooks/use-dam-image'
import {getPriceData} from '../../utils/product-utils'

const ProductVariantsSelectorCard = ({
    data,
    el,
    styles,
    onClose,
    product,
    activeCurrency,
    lastItemThreshold,
    LastFewItemsVariant,
    InfoStockIcon,
    OutOfStockIcon,
}) => {
    const baseUrl = getDamBaseUrl()

    let currentCard = product?.c_subModelIdentifier === el?.productId
    const elData = data?.data?.find((item) => item.id === el?.productId)
    const cardProduct = currentCard ? product : elData
    const elPriceData = getPriceData(cardProduct)

    return (
        <Button
            as={currentCard ? 'button' : RouteLink}
            to={el?.slugUrl}
            {...styles?.drawerCardContainer}
            {...(currentCard && styles.drawerCardCurrent)}
            onClick={() => {
                if (currentCard) {
                    onClose()
                }
            }}
        >
            <Flex {...styles?.drawerCardHeader}>
                <Text {...styles?.drawerCardTitle}>
                    {cardProduct?.c_pdpSelectorName || cardProduct?.name}
                </Text>
                <Flex {...styles?.priceContainer}>
                    <PriceCard
                        priceData={elPriceData}
                        product={cardProduct}
                        activeCurrency={activeCurrency}
                        variant={'pdpSelectorDrawerCard'}
                    />
                    {!cardProduct?.inventory?.orderable && !cardProduct?.c_isPDPWhereToBuy && (
                        <Box {...styles?.outOfStockLabel}>
                            <Fade in>
                                <StockLabel
                                    variant={'selector'}
                                    icon={<OutOfStockIcon />}
                                    textMessage={
                                        <FormattedMessage
                                            id="use_product.message.out_of_stock"
                                            defaultMessage="Out of stock"
                                        />
                                    }
                                />
                            </Fade>
                        </Box>
                    )}
                </Flex>
            </Flex>

            {cardProduct?.inventory?.orderable &&
                cardProduct.inventory.stockLevel <= lastItemThreshold && (
                    <Box>
                        <Fade in>
                            <StockLabel
                                variant={LastFewItemsVariant}
                                icon={<InfoStockIcon circleColor="transparent" />}
                                textMessage={
                                    <FormattedMessage
                                        id="use_product.message.low_stock"
                                        defaultMessage="Last {quantity} {itemLabel}"
                                        values={{
                                            quantity: cardProduct?.inventory?.stockLevel,
                                            itemLabel:
                                                cardProduct?.inventory?.stockLevel === 1 ? (
                                                    <FormattedMessage
                                                        id="global.message.item"
                                                        defaultMessage="item"
                                                    />
                                                ) : (
                                                    <FormattedMessage
                                                        id="global.message.items"
                                                        defaultMessage="items"
                                                    />
                                                ),
                                        }}
                                    />
                                }
                            />
                        </Fade>
                    </Box>
                )}
            {cardProduct?.c_pdpSelectorImage && (
                <Img
                    alt={cardProduct?.id}
                    src={`${baseUrl}/${cardProduct?.c_pdpSelectorImage}`}
                    {...styles?.variantsImage}
                />
            )}

            <Text {...styles?.subModelIdentifier}>{cardProduct?.c_subModelIdentifier}</Text>
        </Button>
    )
}

ProductVariantsSelectorCard.propTypes = {
    styles: PropTypes.object,
    el: PropTypes.object,
    data: PropTypes.object,
    isOpen: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    product: PropTypes.object,
    activeCurrency: PropTypes.string,
    priceData: PropTypes.object,
    lastItemThreshold: PropTypes.number,
    InfoStockIcon: PropTypes.elementType,
    OutOfStockIcon: PropTypes.elementType,
    LastFewItemsVariant: PropTypes.string,
}

export default ProductVariantsSelectorCard
